'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _polished = require('polished');

var _globals = require('./globals.js');

var _globals2 = _interopRequireDefault(_globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getColor = function getColor(_ref) {
	var primary = _ref.primary,
	    success = _ref.success,
	    warning = _ref.warning,
	    danger = _ref.danger,
	    cloud = _ref.cloud;
	var defaultColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#fff';
	var colors = _globals2.default.colors;


	switch (true) {
		case primary:
			return colors.primary;
		case success:
			return colors.success;
		case warning:
			return colors.warning;
		case danger:
			return colors.danger;
		case cloud:
			return colors.cloud;
		default:
			return defaultColor;
	}
};

var getDarkenedColor = function getDarkenedColor(_ref2) {
	var primary = _ref2.primary,
	    success = _ref2.success,
	    warning = _ref2.warning,
	    danger = _ref2.danger,
	    cloud = _ref2.cloud;
	var defaultColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#fff';
	var value = arguments[2];
	var colors = _globals2.default.colors;


	switch (true) {
		case primary:
			return (0, _polished.darken)(value || 0.1, colors.primary);
		case success:
			return (0, _polished.darken)(value || 0.15, colors.success);
		case warning:
			return (0, _polished.darken)(value || 0.1, colors.warning);
		case danger:
			return (0, _polished.darken)(value || 0.1, colors.danger);
		case cloud:
			return (0, _polished.darken)(value || 0.15, colors.cloud);
		default:
			return defaultColor;
	}
};

var getLightenedColor = function getLightenedColor(_ref3) {
	var primary = _ref3.primary,
	    success = _ref3.success,
	    warning = _ref3.warning,
	    danger = _ref3.danger,
	    cloud = _ref3.cloud;
	var defaultColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#fff';
	var value = arguments[2];
	var colors = _globals2.default.colors;


	switch (true) {
		case primary:
			return (0, _polished.lighten)(value || 0.35, colors.primary);
		case success:
			return (0, _polished.lighten)(value || 0.3, colors.success);
		case warning:
			return (0, _polished.lighten)(value || 0.35, colors.warning);
		case danger:
			return (0, _polished.lighten)(value || 0.35, colors.danger);
		case cloud:
			return (0, _polished.lighten)(value || 0.3, colors.cloud);
		default:
			return defaultColor;
	}
};

exports.default = {
	getColor: getColor,
	getDarkenedColor: getDarkenedColor,
	getLightenedColor: getLightenedColor
};